import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../../config/axions.config';
import Swal from 'sweetalert2';
import { showDate } from '../../constant';

const EditUser = () => {
  let navigate = useNavigate();
  let location = useLocation();
  let data = location.state

  const [roleList, setRoleList] = useState([]);

  const [firstname, setFirstame] = useState(data?.firstname);
  const [lastname, setLastname] = useState(data?.lastname);
  const [username, setUsername] = useState(data?.username);
  const [password, setPassword] = useState(data?.password);
  const [email, setEmail] = useState(data?.email);
  const [mobile, setMobile] = useState(data?.mobile);
  const [gender, setGender] = useState(data?.gender);
  const [role, setRole] = useState(data?.userRole.type);
  const [userActive, setUserActive] = useState(data?.is_active);

  async function getRoleList() {
    try {
      let responce = await api.get("userRole")
      if (responce?.data.status) {
        setRoleList(responce.data.data.userRoleType);
      } else {
        toast.error(responce.data.message)
      }
    } catch (error) {
      console.log(error);
    }
  }
  
  async function updateUser(e) {
    
    if (password !== data?.password) {
      let ans = prompt("Chnage password, write Yes to conform.")
      if (ans === "Admin@creart") {
        toast.success("Changin Password.")
      }
      else{
        setPassword(data?.password)
      }
    }

    Swal.fire({
      title: "Update User?",
      text: "Do you want to Update User",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4CAF50",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Create."
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (!firstname || !lastname || !email || !mobile || !username || !password || !role | !gender || userActive) toast.error("Some fileds are emplty");
        try {
          let body = {
            firstname,
            lastname,
            email,
            mobile,
            username,
            password,
            role,
            gender,
            is_active: userActive
          }
          let responce = await api.patch(`user/${data._id}`, body);
          if (responce.data.status) {
            toast.success(responce.data.message);
            navigate("/dashboard/user/")
          }
          else {
            toast.error(responce.data.message);
          }
        } catch (error) {
          toast.error(error.response.data.message);
          let list = error.response.data.errors || [];
          for (let item of list) {
            toast.warning(item.msg)
          }
        }
      } else {
        toast.error("OK! request cancle.")
      }
    });
  }

  useEffect(() => {
    getRoleList();
  }, [])

  return (
    <div className='grow ms-0 md:ms-0 lg:ms-56'>
      <div className="px-4 mt-6 mb-8 sm:px-6 lg:px-8">
        <nav className="sm:hidden" aria-label="Back">
          <div className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
            <svg className="flex-shrink-0 w-5 h-5 mr-1 -ml-1 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
            </svg>
            Back
          </div>
        </nav>

        <nav className="hidden sm:flex" aria-label="Breadcrumb">
          <ol className="flex items-center space-x-4">
            <li>
              <div>
                <div className="text-gray-400 hover:text-gray-500">
                  <svg className="flex-shrink-0 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                  </svg>
                  <span className="sr-only">Home</span>
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <div className="ml-4 text-sm text-gray-500 hover:text-gray-700" onClick={() => navigate('/dashboard/user/')}>
                  User
                </div>
              </div>
            </li>

            <li>
              <div className="flex items-center">
                <svg className="flex-shrink-0 w-5 h-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
                <div className="ml-3 text-sm text-gray-500 hover:text-gray-700" aria-current="page">
                  Edit User
                </div>
              </div>
            </li>
          </ol>
        </nav>

        <hr className="my-5 border-gray-300" />

        <div className="lg:flex lg:items-center lg:space-x-8">
          <div className="lg:flex-1 lg:min-w-0">
            <h1 className="text-2xl font-semibold text-primary-600">
              User
            </h1>
            <div className="mt-2 md:mt-3 sm:flex sm:items-center sm:space-x-6">
              <div className="flex items-center space-x-3">
                <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                  <polyline points="80 40 24 128 80 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                  <polyline points="176 40 232 128 176 216" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></polyline>
                </svg>
                <span className="text-gray-600">
                  User Id - {data._id}
                </span>
              </div>

              <div className="flex items-center mt-3 space-x-3 sm:mt-0">
                <svg className="w-5 h-5 text-gray-500" stroke="currentColor" viewBox="0 0 256 256">
                  <rect x="40" y="40" width="176" height="176" rx="8" strokeWidth="20" strokeLinecap="round" strokeLinejoin="round" fill="none"></rect>
                  <line x1="176" y1="20" x2="176" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  <line x1="80" y1="20" x2="80" y2="40" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                  <line x1="40" y1="88" x2="216" y2="88" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="20"></line>
                </svg>
                <span className="text-gray-600">
                  Started {showDate(data.created_at)}
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center mt-5 ml-auto space-x-6 lg:justify-end lg:mt-0 lg:flex-shrink-0">
            <div className="flex items-center space-x-2">
              <label htmlFor="">
                User Status
              </label>
              <div className="toggle-switch">
                <input type="checkbox" id="toggleSwitch" checked={userActive} onChange={() => setUserActive(!userActive)} value={true} />
                <label htmlFor="toggleSwitch"></label>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 space-y-6">
          <div className="bg-white rounded-lg shadow">
            <div className="px-4 py-3 sm:px-6">
              <div className='flex justify-between items-center'>
                <div className="flex items-center -ml-2">
                  <div title="Back" className="btn-circle" aria-label="Back" data-microtip-position="top" data-target="tooltip" role="button" onClick={() => navigate('/dashboard/user/')}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                  </div>

                  <h2 className="ml-2 text-lg font-medium leading-6 text-gray-900">
                    Edit User
                  </h2>
                </div>
              </div>
            </div>

            <div className="px-4 py-5 border-t border-gray-300 sm:px-6">
              <div>
                <form action={(e) => updateUser(e)}>
                  <div className="grid grid-cols-3 sm:grid-cols-3 gap-x-5 gap-y-4">
                    <div className="col-span-1 sm:col-span-3 md:col-span-1">
                      <label htmlFor="">
                        First Name <span className="text-primary-600">*</span>
                      </label>
                      <div className="mt-1">
                        <input type="text" value={firstname} onChange={(e) => setFirstame(e.target.value)} name="" id="" placeholder="" className="" required />
                      </div>
                    </div>

                    <div className="col-span-1 sm:col-span-3 md:col-span-1">
                      <label htmlFor="">
                        Last Name <span className="text-primary-600">*</span>
                      </label>
                      <div className="mt-1">
                        <input type="text" value={lastname} onChange={(e) => setLastname(e.target.value)} name="" id="" placeholder="" className="" required />
                      </div>
                    </div>

                    <div className="col-span-1 sm:col-span-3 md:col-span-1">
                      <label htmlFor="">
                        Gender <span className="text-primary-600">*</span>
                      </label>
                      <div className="mt-1">
                        <select name="" id="" className="" value={gender} onChange={(e) => setGender(e.target.value)}>
                          <option value="">
                            Please choose gender...
                          </option>
                          <option value="male">
                            Male
                          </option>
                          <option value="female">
                            Female
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="col-span-1 sm:col-span-3 md:col-span-1">
                      <label htmlFor="">
                        Email <span className="text-primary-600">*</span>
                      </label>
                      <div className="mt-1">
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} name="" id="" placeholder="" className="" required />
                      </div>
                    </div>

                    <div className="col-span-1 sm:col-span-3 md:col-span-1">
                      <label htmlFor="">
                        Contact <span className="text-primary-600">*</span>
                      </label>
                      <div className="mt-1">
                        <div className="relative rounded-md shadow-sm">
                          <input type="number" value={mobile} onChange={(e) => setMobile(e.target.value)} name="" id="" placeholder="" className="" required />
                        </div>
                      </div>
                    </div>

                    <div className="col-span-1 sm:col-span-2 md:col-span-1">
                      <label htmlFor="">
                        Role <span className="text-primary-600">*</span>
                      </label>
                      <div className="mt-1">
                        <select onChange={(e) => { setRole(e.target.value) }} >
                          <option value={null}>
                            {role}
                          </option>
                          {
                            roleList?.map(item => (
                              <option key={item._id} value={item._id}>
                                {item.type}
                              </option>
                            ))
                          }
                        </select>
                      </div>
                    </div>

                    <div className="col-span-3 sm:col-span-1 md:col-span-3">
                      <div className='grid grid-cols-3 sm:grid-cols-3 gap-x-5 gap-y-4'>
                        <div className="col-span-1 sm:col-span-3 md:col-span-1">
                          <label htmlFor="">
                            User Name <span className="text-primary-600">*</span>
                          </label>
                          <div className="mt-1">
                            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} name="" id="" placeholder="" className="" required />
                          </div>
                        </div>

                        <div className="col-span-1 sm:col-span-3 md:col-span-1">
                          <label htmlFor="">
                            Password <span className="text-primary-600">*</span>
                          </label>
                          <div className="mt-1">
                            <input type="text" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter New Password" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center justify-end mt-5 space-x-4">
                    <button type="button" className="btn btn-light" onClick={() => navigate('/dashboard/user/')}>
                      Back
                    </button>

                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditUser
